import axios from 'axios'
import { OAuthUrlBase } from './config'

const oauth = {}

oauth.getSentEmails = async data => {
  const { pagination, responseStatus, search } = data
  const { page, sortBy, descending, itemsPerPage } = pagination
  try {
    const request = {
      method: 'GET',
      params: {
        descending,
        limit: itemsPerPage,
        page,
        responseStatus,
        search,
        sortBy
      },
      url: `${OAuthUrlBase}gmail/sent/emails`
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

oauth.sendMessage = async data => {
  try {
    const { from, message, subject, to } = data
    const request = {
      data: {
        from: from,
        to: to,
        subject: subject,
        message: message
      },
      method: 'POST',
      url: `${OAuthUrlBase}gmail/send/message`
    }

    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default oauth
